import {getBaseURL, getQueryVariable} from "../utils/utils";
import {logger} from "../service/LoggerService";

export const baseUrl = getBaseURL()

export function getAndStoreApiUserTokenFromUrl() {
    logger.log("getAndStoreApiUserTokenFromUrl")
    let token = getQueryVariable('token');
    logger.log('token from query variable: ' + token)

    const currentToken = localStorage.getItem('token');
    logger.log('currentToken: ' + currentToken)

    if (token !== currentToken && token) {
        logger.log('New token, so setting local storage')
        localStorage.setItem('token', token)
    }
    return token;
}

export function saveToken(token){
    logger.log("Received token : "+ token)
    localStorage.setItem('token', token)
    return token
}

export function getApiUserToken() {
    logger.log('getApiUserToken')
    const token = localStorage.getItem('token');
    logger.log(`token: ${token}`)
    return token
}

function getHeadersWithToken(token=null) {
    let savedToken = getApiUserToken()
    if (!savedToken){
        savedToken = token
    }
    return {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' +  savedToken,
        'Content-Type': 'application/json'
    };
}

function getHeadersWithTokenForFileUpload() {
    return {
        'Authorization': 'Bearer ' + getApiUserToken()
    };
}

export function saveExtendedListing(extendedListingId, fields) {
    let url = baseUrl + '/widgets-support/extendedListingUpdate/' + extendedListingId

    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body: JSON.stringify(fields)
    }).then(response => response.json())
}

export async function getCampaignOptions(listingAdId) {
    let url = baseUrl + `/widgets-support/campaign/${listingAdId}/options`;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken(),
    }).then(response => response.json())
}

export async function updateExtendedListingWithBudgetCampaignConfig(extendedListingId, selectedPackage, selectedBudgetType) {
    let url = baseUrl + '/widgets-support/updateExtendedListingForCampaign';
    const campaignConfig = {
        extendedListingId,
        packageType: selectedPackage,
        budgetType: selectedBudgetType
    };
    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body: JSON.stringify(campaignConfig)
    }).then(response => response.json())
}

export async function createAfterNoteListingAdForExtListing(extListingId, selAftNoteBudgetType)
{
    let url = baseUrl + '/widgets-support/createAfterNoteListingForExtListing';
    const postData = {
        extListingId, 
        afterNoteBugdet: selAftNoteBudgetType
    };
    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body: JSON.stringify(postData)
    }).then(response => response.json())
}

export async function me() {
    let url = baseUrl + '/widgets-support/me';
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken()
    }).then(response => response.json());
}

export async function campaignSettingsForExtendedListingId(extendedListingId, token) {
    let url = baseUrl + '/widgets-support/campaignSettingsForExtendedListing?extendedListingId=' +  extendedListingId;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken(token)
    }).then(response => response.json());
}

export async function getListing(externalListingId) {
    let url = baseUrl + '/widgets-support/extendedListingAndCampaignInfo?extListingId=' + externalListingId;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken()
    }).then(response => response.json());
}

export async function getAfterNoteCampaignInfo(externalListingId, token) {
    let url = baseUrl + '/widgets-support/afterNoteAdAndCampaignInfo?extListingId=' + externalListingId;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken(token)
    }).then(response => response.json());
}

export async function getAfterNoteListing(externalListingId) {
    let url = baseUrl + '/widgets-support/extendedListingAndCampaignInfo?extListingId=' + externalListingId;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken()
    }).then(response => response.json());
}

export async function getListingBrief(externalListingId) {
    let url = baseUrl + '/widgets-support/extendedListingByExtListingId?extListingId=' + externalListingId;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken()
    }).then(response => response.json());
}

// TODO: remove this, and in backend
// export async function getCampaignInfoPreview(externalListing, token) {
//     let url = baseUrl + '/widgets-support/campaignPreview'
//     return fetch(url, {
//         method: 'POST',
//         headers: getHeadersWithToken(),
//         body: JSON.stringify(externalListing)
//     }).then(response => response.json());
// }

export async function getQuedroListingData(externalListingId) {
    let url = baseUrl + '/widgets-support/quedroDataByExtListingId?extListingId=' + externalListingId;
    return fetch(url,
        {
            method: 'GET',
            headers: getHeadersWithToken()
        }).then(response => response.json());
}

export async function getListingAd(id) {
    let url = baseUrl + '/widgets-support/listingAd/' + id;
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken()
    }).then(response => response.json());
}

export function saveListingAd(id, fields) {
    let url = baseUrl + '/widgets-support/listingAd/' + id
    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body: JSON.stringify(fields)
    }).then(response => response.json())
}

export function saveListingAdImage(id, formData) {
    let url = baseUrl + '/widgets-support/listingAd/' + id
    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithTokenForFileUpload(),
        body: formData
    }).then(response => console.log("response: " + response))
}


export function forceExtendedListingToOnHold(id) {
    let url = baseUrl + '/widgets-support/forceExtendedListingToOnHold/' + id
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken(),
    }).then(response => response.json())
}

export function forceAfterNoteListingToOnHold(id) {
    let url = baseUrl + '/widgets-support/forceAfterNoteListingToOnHold/' + id
    return fetch(url, {
        method: 'GET',
        headers: getHeadersWithToken(),
    }).then(response => response.json())
}

export async function sendVendorStatisticsEmail(vendorStats) {
  let url = baseUrl + '/widgets-support/emailcampaignstats';
  const response = await fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body: JSON.stringify(vendorStats),
    });
    return await response.json();
}

export async function listingValidation(params){
    let url = baseUrl + "/widgets-support/listingvalidation"
    return fetch(url, {
        method: 'POST',
        headers: getHeadersWithToken(),
        body : JSON.stringify(params)
    }).then(response => response.json())
}

export async function uploadandfetchImage(formData){
    let url = baseUrl + '/widgets-support/uploadafternoteimage'
    const response = await fetch(url, {
        method : 'POST',
        headers : getHeadersWithTokenForFileUpload(),
        body : formData
    })
    return await response.json()
}